/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import CreateModal from 'components/custom/modal/CreateModal';
import InputBox from 'components/custom/forms/InputBox';
import { useFormik } from 'formik';
import useModalManage from 'hooks/custom/useModalManage';
import * as Yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import LabelInput from 'components/custom/forms/LabelInput';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import useManageLocation from 'hooks/custom/useManageLocation';
import apiEndpoints from 'constants/apiEndpoints';

const CreateVehicleType = ({ show, handleClose, handleRefresh }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const { country, state, city, manageLocation } = useManageLocation();
  const { showAlert } = useAlert();

  const handleCreateCreateVehicleType = async values => {
    setModalLoading(true, 'Creating Vehicle Type');
    const request = await postData(values, apiEndpoints.vehicleType.create);
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to create the Vehicle Type ${values.vehicle_name}.`
      });
      handleRefresh();
      handleClose();
    } else {
      setModalLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to create the Vehicle Type ${values.vehicle_name}.`
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      vehicle_name: ''
    },
    validationSchema: Yup.object({
      vehicle_name: Yup.string()
        .required('Please Enter the Vehicle Type')
        .max(30, 'Vehicle Type cannot be longer than 30 characters')
    }),

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSubmit: values => {
      handleCreateCreateVehicleType(values);
    }
  });

  const handleLocationChange = (name, value) => {
    manageLocation(formik, name, value);
  };

  return (
    <CreateModal
      show={show}
      loading={modalLoading}
      loadingText={modalMessage}
      handleClose={handleClose}
      heading={'Create Vehicle Type'}
      handleSubmit={formik.handleSubmit}
    >
      <Row className="gy-2 gx-2">
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelInput
              label={'Vehicle Type'}
              controlId={'vehicle_name'}
              formik={formik}
              errorProps={{ tooltip: false }}
            />
          </InputBox>
        </Col>
      </Row>
    </CreateModal>
  );
};

export default CreateVehicleType;
